document.addEventListener('DOMContentLoaded', function() {
    initializeGallerySliders();
    initializeAdultCheck();
    
    if (typeof galleryAjaxData !== 'undefined' && galleryAjaxData.enableInfiniteScroll === 'yes') {
        initializeInfiniteScroll();
    }
});

function initializeGallerySliders() {
    const patientCases = document.querySelectorAll('.gallery__cases__case');
    if (!patientCases) return;

    patientCases.forEach((item) => {
        let patientsSlider = item.querySelector('.patients-slider:not(.is-initialized)');
        let thumbnailSlider = item.querySelector('.patients-thumbnail-slider:not(.is-initialized)');
        
        if (patientsSlider && thumbnailSlider) {
            initializeSplideSliders(patientsSlider, thumbnailSlider);
        }
    });
}

function initializeSplideSliders(mainSlider, thumbnailSlider) {
    if (!mainSlider || mainSlider.classList.contains('is-initialized')) {
        return;
    }

    // Check if there are actually slides before initializing
    const mainSlides = mainSlider.querySelectorAll('.splide__slide');
    if (!mainSlides.length) {
        console.warn('No slides found in main slider');
        return;
    }

    // Remove visibility: hidden that Splide adds
    mainSlider.style.visibility = 'visible';
    
    try {
        // Initialize main slider first
        var main = new Splide(mainSlider, {
            type: 'fade',
            rewind: true,
            pagination: false,
            drag: false,
            arrows: true
        });

        // Mount main slider immediately
        main.mount();
        mainSlider.classList.add('is-initialized');

        // Handle thumbnail slider separately
        if (thumbnailSlider && !thumbnailSlider.classList.contains('is-initialized')) {
            thumbnailSlider.style.visibility = 'visible';
            const thumbSlides = thumbnailSlider.querySelectorAll('.splide__slide');
            
            if (thumbSlides.length) {
                var thumbnails = new Splide(thumbnailSlider, {
                    fixedWidth: 100,
                    fixedHeight: 60,
                    rewind: true,
                    pagination: false,
                    arrows: false,
                    drag: false,
                    isNavigation: true,
                    breakpoints: {
                        600: {
                            fixedWidth: 60,
                            fixedHeight: 44,
                        },
                    },
                });

                // Mount thumbnail slider before syncing
                thumbnails.mount();
                thumbnailSlider.classList.add('is-initialized');

                // Sync after both sliders are mounted
                main.sync(thumbnails);
            }
        }

    } catch (error) {
        console.error('Error initializing Splide:', error);
        // Cleanup in case of error
        if (main && typeof main.destroy === 'function') {
            main.destroy();
        }
        if (thumbnails && typeof thumbnails.destroy === 'function') {
            thumbnails.destroy();
        }
    }
}

function initializeAdultCheck() {
    var body = document.querySelector('body');
    var mainContent = document.querySelector('main.gallery');
    var modal = document.getElementById('adult-check-modal');
    if (!modal) return;

    var confirmBtn = document.getElementById('confirm-age');
    var denyBtn = document.getElementById('deny-age');

    body.classList.add('scroll-lock');
    mainContent.classList.add('blur-background');

    if (getCookie('adultConfirmed') !== 'true') {
        modal.style.display = 'block';
        mainContent.classList.add('blur-background');
        confirmBtn.focus();     
    }

    confirmBtn.addEventListener('click', function() {
        modal.style.display = 'none';
        body.classList.remove('scroll-lock');
        mainContent.classList.remove('blur-background');
    });

    denyBtn.addEventListener('click', function() {
        const galleryHome = '/' + new URL(location.href).pathname.split("/")[1] + '/';
        window.location.href = galleryHome;
    });   
}

function initializeInfiniteScroll() {
    if (typeof galleryAjaxData === 'undefined') {
        console.log('Gallery Ajax Data not found - stopping infinite scroll init');
        return;
    }

    let currentPage = 1;
    let isLoading = false;
    let hasMorePosts = true;
    const loadMoreTrigger = document.getElementById('load-more-trigger');
    const backToTopBtn = document.getElementById('back-to-top');
    const galleryContainer = document.querySelector('.gallery__cases');

    if (!loadMoreTrigger || !backToTopBtn || !galleryContainer) {
        console.log('Missing required elements - stopping infinite scroll init');
        return;
    }

    // Add scroll event listener for back to top button
    window.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            backToTopBtn.classList.add('visible');
        } else {
            backToTopBtn.classList.remove('visible');
        }
    });

    // Add click event for back to top button
    backToTopBtn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    
    async function loadMorePosts() {
        if (isLoading) {
            return;
        }
        
        isLoading = true;
        currentPage++;

        try {
            const response = await fetch(galleryAjaxData.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'load_more_patients',
                    nonce: galleryAjaxData.nonce,
                    page: currentPage,
                    term_id: galleryAjaxData.termId,
                    gallery_style: galleryAjaxData.galleryStyle,
                    posts_per_page: 9
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success && data.data.html) {
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = data.data.html;

                const newCases = tempContainer.querySelectorAll('.gallery__cases__case');
                
                // Process each case one at a time with a small delay
                for (const caseElement of newCases) {
                    galleryContainer.appendChild(caseElement);
                    
                    // Wait for a frame to ensure DOM is updated
                    await new Promise(resolve => {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                const mainSlider = caseElement.querySelector('.patients-slider');
                                const thumbSlider = caseElement.querySelector('.patients-thumbnail-slider');
                                
                                if (mainSlider) mainSlider.style.visibility = 'visible';
                                if (thumbSlider) thumbSlider.style.visibility = 'visible';
                                
                                if (mainSlider && thumbSlider) {
                                    initializeSplideSliders(mainSlider, thumbSlider);
                                }
                                resolve();
                            });
                        });
                    });
                }

                hasMorePosts = data.data.hasMore;

                if (!hasMorePosts) {
                    loadMoreObserver.unobserve(loadMoreTrigger);
                    loadMoreTrigger.style.display = 'none';
                }
            }
        } catch (error) {
            console.error('Error loading more posts:', error);
        } finally {
            isLoading = false;
        }
    }

    const observerOptions = {
        root: null,
        rootMargin: '100px',
        threshold: 0.1
    };

    const loadMoreObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isLoading && hasMorePosts) {
                loadMorePosts();
            }
        });
    }, observerOptions);

    loadMoreObserver.observe(loadMoreTrigger);
}

// Cookie helper functions
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}